import {useRef} from 'react';

export const useSingleton = <T>(create: () => T): T => {
  const instanceRef = useRef<T | null>(null);

  if (instanceRef.current === null) {
    instanceRef.current = create();
  }

  return instanceRef.current;
};
